// extracted by mini-css-extract-plugin
module.exports = {"List":"nedCJU2K5hvqcyB_Xzj68"};